<!--
 * @Author: lzz
 * @Date: 2024-06-08 10:27:41
 * @LastEditTime: 2024-09-05 23:55:44
-->
<!--
 * @Author: lzz
 * @Date: 2024-06-08 10:27:41
 * @LastEditTime: 2024-06-13 13:32:16
-->
<template>
	<div class="base" :class="{ 'is-mobile': isMobile }">
		<div class="home" id="home" v-if="pageVisible">
			<div class="top-bg">
				<img src="@/assets/img/top1.png" alt="" />
			</div>
			<el-tooltip class="feed-back" effect="dark" content="意见反馈" placement="top-start" v-if="!isMobile && !welcomeIn && !guideVisible && !guide2Visible">
				<img src="@/assets/img/feedback.png" @click="doFeelback()" />
			</el-tooltip>
			<div class="operate">
				<template v-if="!isMobile">
					<el-tooltip class="item" effect="dark" content="首页" placement="top-start">
						<img src="@/assets/img/icon4.png" alt="" @click="handleRoute('home')" />
					</el-tooltip>

					<el-tooltip class="item" effect="dark" content="个人中心" placement="top-start">
						<img src="@/assets/img/icon5.png" @click="handleRoute('personCenter')" />
					</el-tooltip>
				</template>
				<template v-else>
					<img class="item" src="@/assets/img/icon4.png" alt="" @click="handleRoute('home')" />
					<img class="item" src="@/assets/img/icon5.png" @click="handleRoute('personCenter')" />
				</template>
				<el-dropdown @command="logOut" trigger="click" v-if="!isMobile" style="vertical-align: top; height: 1vw; line-height: 1vw; margin-top: 1vw; margin-left: 1vw; cursor: pointer">
					<span class="el-dropdown-link">
						<span>{{ userInfo.nickname }}</span
						><i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item style="padding: 0 0.5vw; cursor: pointer">
							<img src="@/assets/img/close5.png" style="width: 1vw; height: 1vw; vertical-align: middle" alt="" @click="logOut" />
							<span @click="logOut" style="display: inline-block; height: 1vw; line-height: 1vw; padding-left: 0.4vw; vertical-align: middle"> 退出登录</span>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<span v-else style="display: inline-block; height: 3.1vw; line-height: 3.1vw; vertical-align: top; font-size: 1.8vw; margin-left: 1vw">{{ userInfo.nickname }}</span>
			</div>
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item, index) in swiperList">
						<div class="swiper-item swiper-fqqz" v-if="item.id == 'fqqz'">
							<div class="fqqz-item">
								<div class="fqqz-item-img" :id="item.id">
									<div class="door-left"></div>
									<div class="door-right"></div>
								</div>
							</div>
						</div>
						<div v-else class="swiper-item" :id="item.id" :style="{ 'background-image': `url(${item.img})` }">
							<span style="font-size: 0">{{ item.name }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="pre-btn" @click="handlePre" v-show="showPager" :style="{ 'z-index': zIndexStyle }">
				<img :src="leftIcon" alt="" />
			</div>
			<div class="next-btn" :style="{ 'z-index': zIndexStyle }" @click="handleNext" v-show="showPager">
				<img :src="rightIcon" alt="" />
			</div>
			<div class="close-icon" @click="closeContent" v-show="!guideVisible && !guide2Visible && !welcomeIn && !showPager"></div>
			<msg v-if="msgVisible" @closeMsg="msgVisible = false"></msg>
		</div>
		<div class="bottom-menu" v-if="!welcomeIn && !guideVisible && !guide2Visible">
			<div class="menu-list">
				<div class="menu-item" :class="{ active: menuIndex == index }" v-for="(item, index) in menuList" :key="index" @click="handleMenuChange(item, index, item.swiperIndex)">
					<img :src="menuIndex == index ? item.activeImg : item.img" :style="{ width: item.width, height: item.height }" />
					<span>{{ item.name }}</span>
				</div>
			</div>
		</div>
		<div class="mobile-adjustment"></div>
		<div class="welcome-bg" v-if="welcomeIn">
			<img src="@/assets/img/w3.png" alt="" @click="handleIn" style="cursor: pointer" />
		</div>
		<div class="guide" v-if="guideVisible">
			<video ref="videoPlayer" :src="guideVodUrl" autoplay @ended="skipGuide" playsinline controlsList="nodownload nofullscreen noremoteplayback"></video>
			<span class="skip" @click="skipGuide">跳过</span>
		</div>
		<div class="guide2" v-if="guide2Visible" @click="lessonListProcessVisible = false">
			<div class="guide2-base" :class="{ 'is-tourist': isTourist }">
				<span class="txt1"
					><span v-if="!isTourist">{{ userInfo.nickname }}: </span>{{ welcomeTxt }}</span
				>
				<span class="txt2" @click="continueLearn">
					<template v-if="isTourist">
						<span>点击浏览</span>
					</template>
					<template v-else>
						<span v-show="welcomeType == 1">进入学习</span>
						<span v-show="welcomeType == 2">继续学习</span>
						<span v-show="welcomeType == 3">继续浏览</span>
					</template>
					<img src="@/assets/img/icon8.png" alt="" />
				</span>
				<span class="txt3" @click.stop="handleShowLessonList" v-show="welcomeType != 3 && !isTourist">
					<span v-show="welcomeType == 1">查看学习清单</span>
					<span v-show="welcomeType != 1">查看学习进度</span>
					<img src="@/assets/img/icon8.png" alt=""
				/></span>
			</div>

			<img :src="rabitImg" />
			<div class="process" @click.stop v-if="lessonList.length > 0 && lessonListProcessVisible" :style="getProcessStyle">
				<div class="close-process">
					<img src="@/assets/img/close1.png" @click="lessonListProcessVisible = false" alt="" />
				</div>
				<div class="process-item" v-for="item in lessonList" @click="toDetails(item)">
					<span style="cursor: pointer"> {{ item.title }}</span>
					<i> </i>
					<span v-if="item.isFinish" style="background-color: #e5e5ff; color: #0000fd"> 完成 100% </span>
					<span v-else>
						完成
						{{ item.studyTime / item.duration > 1 ? 100 : Math.floor((item.studyTime / item.duration) * 100) + "%" }}
					</span>
				</div>
				<!-- <div class="process-item" @click="toOrder('selfvaluate')">
					<span style="cursor: pointer">自评</span>
					<span v-if="currentTerm.isFinishEvaluate" style="background-color: #e5e5ff; color: #0000fd">完成 100%</span>
					<span v-else>完成 0%</span>
				</div> -->
				<div class="process-item" @click="toOrder('exam')">
					<span style="cursor: pointer">“坚持用业绩说话”主题学习考试</span>
					<span v-if="currentTerm.isFinishPaper" style="background-color: #e5e5ff; color: #0000fd">完成 100%</span>
					<span v-else>完成 0%</span>
				</div>
				<div class="process-item" @click="toOrder('promise')">
					<span style="cursor: pointer">“坚持用业绩说话”承诺书签署</span>
					<span v-if="currentTerm.isFinishAgreement" style="background-color: #e5e5ff; color: #0000fd">完成 100%</span>
					<span v-else>完成 0%</span>
				</div>
				<!-- 
				<div class="process-item" @click="toOrder('certificate')">
					<span style="cursor: pointer">证书</span>
					<span v-if="currentTerm.isFinishCredential" style="background-color: #e5e5ff; color: #0000fd">完成 100%</span>
					<span v-else>完成 0%</span>
				</div> -->
			</div>
		</div>
	</div>
</template>
<script>
const loginData = {
	isShowPassword: false,
	loginForm: {
		tenantName: "比特新云源码",
		username: "admin",
		password: "",
		captchaVerification: "",
		rememberMe: true, // 默认记录我。如果不需要，可手动修改
	},
};
const slideW = window.innerWidth / 3;
const radius = (slideW * 0.5) / Math.sin(Math.PI / 6); //半径。圆心并不是视点中心，视点在1200p
import Swiper from "swiper"; // 注意引入的是Swiper
import "swiper/css/swiper.min.css"; // 注意这里的引入
import * as api from "@/api/index";
import msg from "@/components/msg.vue";
import { checkMobile, showFeebackDialog } from "@/utils/index";

export default {
	name: "baseHome",
	data() {
		return {
			rabitImg: require("@/assets/img/rabit.gif"),
			leftIcon: require("@/assets/img/leftIcon.gif"),
			rightIcon: require("@/assets/img/rightIcon.gif"),
			constants: {},
			swiperSpace: 0,
			swiperWidth: 0,
			swiperHeight: 0,
			menuIndex: 0,
			swiper: null,
			welcomeIn: true,
			msgVisible: false,
			username: "",
			password: "",
			showPager: true,
			isMobile: false,
			guideVisible: false,
			guide2Visible: false,
			guideVodUrl: null,
			currentTerm: "",
			lessonList: [],
			finishCount: 0,
			gifTimer: null,
			isTourist: false,
			isGb: false,
			lessonListProcessVisible: false,
			pageVisible: false,
			welcomeTxt: "",
			welcomeType: 1,
			userInfo: {},
			
			swiperList: [
				{
					name: "党群专栏",
					id: "partybuild",
					url: "/partyBuild",
					img: require("@/assets/img/07.jpg"),
					menuIndex: 3,
				},
				{
					name: "CEO寄语",
					id: "executiveMessage",
					url: "/executiveMessage",
					img: require("@/assets/img/05.jpg"),
					activeImg: require("@/assets/img/menu1.png"),
					menuIndex: 1,
				},
				{
					name: "主题学习课堂",
					id: "tinyLesson",
					img: require("@/assets/img/04.jpg"),
					url: "/tinyLesson",
					activeImg: require("@/assets/img/menu2-active.png"),
					menuIndex: 2,
				},
				{
					name: "最佳实践案例",
					id: "departCase",
					img: require("@/assets/img/06.jpg"),
					url: "/departCase",
					menuIndex: 5,
				},
				{
					name: "风清气正",
					id: "fqqz",
					img: require("@/assets/img/menu8.png"),
					url: "https://hrceh.h3c.com/index.html?t=1721639440",
					menuIndex: 0,
				},
				{
					name: "创意主题壁纸",
					id: "subjectDown",
					img: require("@/assets/img/03.jpg"),
					url: "/subjectDown",
					menuIndex: 6,
				},
				{
					name: "部门培训风采",
					id: "departLand",
					url: "/departLand",
					img: require("@/assets/img/01.jpg"),
					menuIndex: 4,
				},
				
			],
			menuList: [
				{
					name: "首页",
					id: "11",
					url: "/home",
					img: require("@/assets/img/menu1.png"),
					activeImg: require("@/assets/img/menu1.png"),
					height: "3.24vh",
					swiperIndex: null,
				},
				{
					name: "CEO寄语",
					id: "22",
					img: require("@/assets/img/menu6.png"),
					activeImg: require("@/assets/img/menu6-active.png"),
					url: "/executiveMessage",
					height: "3.24vh",
					swiperIndex: 1,
				},

				{
					name: "主题学习课堂",
					id: "33",
					img: require("@/assets/img/menu2.png"),
					url: "/tinyLesson",
					activeImg: require("@/assets/img/menu2-active.png"),
					height: "3.24vh",
					swiperIndex: 2,
				},
				{
					name: "党群专栏",
					id: "44",
					url: "/partybuild",
					img: require("@/assets/img/menu9.png"),
					activeImg: require("@/assets/img/menu9-active.png"),
					height: "3.24vh",
					swiperIndex: 0,
				},
				{
					name: "部门培训风采",
					id: "55",
					url: "/departLand",
					img: require("@/assets/img/menu4.png"),
					activeImg: require("@/assets/img/menu4-active.png"),
					height: "3.24vh",
					swiperIndex: 6,
				},
				{
					name: "最佳实践案例",
					id: "66",
					img: require("@/assets/img/menu5.png"),
					url: "/departCase",
					activeImg: require("@/assets/img/menu5-active.png"),
					height: "3.24vh",
					swiperIndex: 3,
				},
				{
					name: "创意主题壁纸",
					id: "77",
					img: require("@/assets/img/menu8.png"),
					activeImg: require("@/assets/img/menu8-active.png"),
					url: "/subjectDown",
					height: "3.24vh",
					swiperIndex: 5,
				},
			],
		};
	},
	components: {
		msg,
	},
	created() {},
	watch: {
		$route(to, from) {
			this.showPager = to.path == "/home";
		},
	},
	computed: {
		getProcessStyle() {
			let style = {};
			if (!this.lessonListProcessVisible) {
				style = {
					height: 0,
					padding: 0,
					border: "none",
				};
			}
			return style;
		},
		zIndexStyle() {
			return this.guide2Visible ? 999 : 0;
		},
	},
	mounted() {
		this.getGuideUrl();
		this.isMobile = checkMobile();
		this.loadUserInfo();
		window.addEventListener("load", this.goToRoot);
	},
	methods: {
		doFeelback() {
			api.feelbackUri({}).then((res) => {
				showFeebackDialog(res.data);
			});
		},
		getGuideUrl() {
			api.getConfigByKey("sems_guide_vod").then((res) => {
				this.guideVodUrl = res.data;
				console.log("guideVodUrl", res);
			});
		},
		closeContent() {
			this.$router.push("/home");
		},
		// 退出登录
		logOut() {
			api
				.logout({
					type: 99,
					redirectUri: location.origin + "/index",
				})
				.then((res) => {
					localStorage.clear();
					window.location.href = res.data;
				});
		},
		toDetails(item) {
			this.guide2Visible = false;
			this.clearTimer();
			this.guideVisible = false;
			this.welcomeIn = false;
			this.menuIndex = 2;
			if (item.fileType == 1) {
				api
					.updateStudy({
						termId: this.currentTerm.id,
						courseId: item.id,
						studyTime: item.duration,
					})
					.then((res) => {
						if (item.required) {
							this.loadTerm();
						}
						this.loadLessonList();
					});
				window.location.href = item.fileId;
			} else {
				this.$router.push("/lessonDetails?id=" + item.id);
			}
		},
		viewMsg() {
			this.msgVisible = true;
		},
		handleShowLessonList() {
			this.lessonListProcessVisible = true;
		},
		goToRoot() {
			// 如果当前路径不是根路径，则跳转到根路径
			if (this.$router.currentRoute.path !== "/" && this.$router.currentRoute.path !== "/index" && this.$router.currentRoute.path !== "/home" && this.$router.currentRoute.path !== "/social-login") {
				this.$nextTick(() => {
					console.log(222);
					window.location.href = "/";
				});
			}
		},
		//加载用户信息
		loadUserInfo() {
			api
				.getUserInfo()
				.then((res) => {
					console.log("user", res.data);
					this.userInfo = res.data;
					this.pageVisible = true;
					if (res.data.groupId == 4 || res.data.isWork >= 1) {
						this.isTourist = true;
						localStorage.setItem("isTourist", this.isTourist);
					} else {
						localStorage.setItem("isTourist", false);
					}
					if (res.data.groupId == 2) {
						this.isGb = true;
						localStorage.setItem("isGb", true);
					} else {
						localStorage.setItem("isGb", false);
					}
					this.welcomeIn = true;
					this.$nextTick(() => {
						this.initSwiper();
						this.loadTerm();
						this.loadLessonList();
					});
				})
				.catch((err) => {
					// if (err == 401) {
					//   this.handleToSsoLogin();
					// }
				});
		},
		toOrder(url) {
			this.guide2Visible = false;
			this.clearTimer();
			this.guideVisible = false;
			this.welcomeIn = false;
			if (!this.currentTerm.isFinishCourse) {
				//课程未学习完
				this.$router.push("/tinyLesson");
			} else {
				if (!this.currentTerm.isFinishPaper) {
					this.$router.push("/exam");
				} else if (!this.currentTerm.isFinishAgreement) {
					this.$router.push("/promise");
				} else if (!this.currentTerm.isFinishCredential) {
					this.$router.push("/certificate");
				}
			}
		},
		//获取当前课程信息
		loadTerm() {
			api.getCurrentTerm().then((res) => {
				const currentTerm = res.data;
				this.currentTerm = currentTerm;
				const termCoursesTotal = currentTerm.termCoursesTotal;
				if (termCoursesTotal[1].value == 0 && termCoursesTotal[3].value == 0) {
					this.welcomeTxt = "欢迎进入主题展厅，请开启您的学习之旅吧";
					this.welcomeType = 1;
				} else if (currentTerm.isFinishAgreement && currentTerm.isFinishCourse && currentTerm.isFinishPaper && currentTerm.isFinishCredential) {
					this.welcomeTxt = "您已完成全部必修内容，请继续浏览参观吧";
					this.welcomeType = 3;
				} else {
					this.welcomeTxt = "欢迎回来，请继续学习吧";
					this.welcomeType = 2;
				}
				if (this.isTourist) {
					this.welcomeTxt = "欢迎光临“坚持用业绩说话”主题展厅";
				}
				localStorage.setItem("currentTerm", JSON.stringify(currentTerm));

				let lessonScheduleList = [
					{
						title: "我的课程",
						count: 0,
						value: 0,
						url: "/personCenter",
						show: true,
					},
					{
						title: "我的考试",
						url: "/myExam",
						show: false,
					},
					{
						title: "我的承诺书",
						url: "/myPromise",
						show: false,
					},
					{
						title: "我的证书",
						url: "/myCert",
						show: false,
					},
					{
						title: "我的互动",
						url: "/myInteraction",
						show: true,
					},
				];
				lessonScheduleList[1].show = currentTerm.isFinishPaper;
				lessonScheduleList[2].show = currentTerm.isFinishAgreement;
				lessonScheduleList[3].show = currentTerm.isFinishCredential;
				localStorage.setItem("lessonScheduleList", JSON.stringify(lessonScheduleList));
			});
		},
		//加载课程信息
		loadLessonList() {
			api
				.getTerm({
					termCoursesTotal: "统计指标",
					termCourses: "课件列表",
					pageSize: 99,
					pageNo: 1,
				})
				.then((res) => {
					this.lessonList = res.data.list.filter((item) => item.required === true);
					this.finishCount = res.data.list.filter((item) => item.isFinish === true).length;
				});
		},
		continueLearn() {
			this.guide2Visible = false;
			this.clearTimer();
			this.guideVisible = false;
			this.welcomeIn = false;
			if (this.welcomeType != 3) {
				this.menuIndex = 2;
				this.swiper.slideToLoop(2-1, 2000);
				this.$router.push("/tinyLesson");
			} else {
				this.swiper.slideToLoop(1-1, 2000);
				this.$router.push("/home");
			}
		},
		replayGuide() {
			this.guideVisible = true;
			this.guide2Visible = false;
			this.clearTimer();
			this.$refs.videoPlayer.play(); // 播放视频
		},
		//跳过视频
		skipGuide() {
			this.$refs.videoPlayer.pause(); // 暂停视频
			this.$refs.videoPlayer.currentTime = 0;
			this.guideVisible = false;
			this.welcomeIn = false;
			this.guide2Visible = true;
			this.gifTimer = setInterval(() => {
				this.rabitImg = require("@/assets/img/rabit.gif") + "?" + Math.random();
			}, 4000);
		},
		async handleToSsoLogin() {
			let type = 99;
			let redirect = "/index";
			const redirectUri = location.origin + "/#/social-login?" + encodeURIComponent(`type=${type}&redirect=${redirect || "/"}`); // 进行跳转
			api
				.socialAuthRedirect({
					type: type,
					redirectUri: redirectUri,
				})
				.then((res) => {
					console.log("ressss", res);
					setTimeout(() => {
						window.location.href = res.data;
					}, 10000);
				});
			//
		},
		handleToSsoLogin2() {
			let type = 99;
			let redirect = "/";
			const redirectUri = "http://h3cwkend.bitxcloud.com/social-login?" + encodeURIComponent(`type=${type}&redirect=${redirect || "/"}`); // 进行跳转
			console.log("redirectUri", redirectUri);
			api
				.socialAuthRedirect({
					type: type,
					redirectUri: "http://h3cwkend.bitxcloud.com/social-login?type%3D99%26redirect%3D%2Findex",
				})
				.then((res) => {
					window.location.href = res.data;
				});
		},

		handleRoute(url) {
			if (url == "home") {
				this.loadLessonList();
				this.loadTerm();
				this.guide2Visible = true;
			}
			this.$router.push("/" + url);
		},
		handleIn() {
			this.guideVisible = true;
		},
		handleMenuChange(item, index, swiperIndex) {
			this.menuIndex = index;

			if (item.url) {
				if (item.url == "/home") {
					this.loadLessonList();
					this.loadTerm();
					this.guide2Visible = true;
				}
				this.$router.push(item.url);
			}
			if (swiperIndex !== null) {
				this.swiper.slideToLoop(swiperIndex-1, 2000);
			}
		},
		handleNext() {
			if (this.guide2Visible) {
				this.guideVisible = false;
				this.guide2Visible = false;
				this.clearTimer();
			} else {
				this.swiper.slideNext();
			}
		},
		handlePre() {
			if (this.guide2Visible) {
				this.guideVisible = false;
				this.guide2Visible = false;
				this.clearTimer();
			} else {
				this.swiper.slidePrev();
			}
		},
		clearTimer() {
			if (this.gifTimer) {
				clearInterval(this.gifTimer);
				this.gifTimer = null; // 重置timerId
			}
		},
		initSwiper() {
			var _that = this;
			this.swiper = new Swiper(".swiper-container", {
				watchSlidesProgress: true,
				slidesPerView: "auto",
				centeredSlides: false,
				loop: true,
				grabCursor: true,
				on: {
					click: (item) => {
						if (item.target.innerText.length > 100) {
							return;
						}
						var foundSwiper = _that.swiperList.find((s) => {
							return s.id == item.target.id
						})
						if (foundSwiper.id == "fqqz") {
							window.open("https://hrceh.h3c.com/index.html?t=1721639440");
							
						} else {
							_that.menuIndex = foundSwiper.menuIndex;
							_that.$router.push(foundSwiper.url);
						}
					},
					progress: function (swiper, progress) {
						for (var i = 0; i < this.slides.length; i++) {
							var slide = this.slides[i];
							var slideProgress = this.slides[i].progress;
							const translateX = (slideProgress + 1) * (slideW / 3 - (Math.cos(((slideProgress + 1) * Math.PI) / 6) * slideW * 1.2) / 3) + "px"; // 调整图片间距
							const rotateY = (slideProgress + 1) * 30; // 图片角度
							const translateZ = radius - Math.cos(((slideProgress + 1) * Math.PI) / 6) * radius - 150 + "px"; // 调整图片远近
							slide.style.transform = "translateX(" + translateX + ") translateZ(" + translateZ + ") rotateY(" + rotateY + "deg)";
						}
					},
					setTransition: function (swiper, transition) {
						for (var i = 0; i < this.slides.length; i++) {
							var slide = this.slides[i];
							slide.style.transition = transition;
						}
					},
					slideChange: function(){
						console.log('activeIndex为'+(this.activeIndex-7));
						_that.menuIndex = _that.swiperList[this.activeIndex-7+1].menuIndex;
					}
				},
			});
		},
		loadSwiperSet() {
			this.swiperSpace = document.body.clientWidth * 0.4635;
			this.swiperHeight = document.body.clientHeight * 0.2648;
			this.swiperWidth = document.body.clientWidth * 0.2677;
		},
	},
	beforeDestroy() {
		// 组件销毁前，移除监听
		window.removeEventListener("load", this.goToRoot);
	},
};
</script>
<style>
.el-dropdown-menu__item,
.el-menu-item {
	padding: 0 1vw;
}

.el-dropdown-menu {
	margin: 0;
	padding: 0;
}
</style>
<style lang="scss">
.base {
	&.is-mobile {
		.process-item span:last-child {
			width: 8vw !important;
		}
		.close-process {
			img {
				width: 2vw;
				height: 2vw;
			}
		}
	}
	@media (max-width: 767px) {
		.mobile-adjustment {
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: 99;
			background-image: url("@/assets/img/hp.jpg");
			background-position: center;
			background-size: contain;
			background-color: #000000;
			z-index: 9999;
		}
	}

	/* 横屏（landscape）样式 */
	@media screen and (orientation: landscape) {
		.mobile-adjustment {
			display: none !important;
		}
	}
	.guide {
		position: fixed;
		background-color: rgba(255, 255, 255, 0.1);
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 100;
		width: 100%;
		height: 100%;

		video {
			display: block;
			width: 100%;
			height: 100%;
		}

		.skip {
			position: fixed;
			right: 2vw;
			top: 2vw;
			cursor: pointer;
			color: #000;
			font-size: 1.5vw;
			font-weight: bold;
			width: 4vw;
			height: 3vw;
			line-height: 3vw;
			text-align: center;
		}
	}

	.guide2 {
		position: fixed;
		background-image: url("@/assets/img/guide2.png");
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 99;
		background-size: cover;
		background-position: center;

		.guide2-base {
			width: 60vw;
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
			height: 15vh;
			background-image: url("@/assets/img/guide2-base.png");

			&.is-tourist {
				.txt2 {
					left: 73% !important;
				}
			}

			.txt1 {
				position: absolute;
				top: 50%;
				transform: translateY(-60%);
				left: 12%;
				font-family: SourceHanSansCN;
				font-weight: 800;
				font-size: 0.9vw;
				color: #1f2c6e;
			}

			.txt2 {
				position: absolute;
				top: 48%;
				transform: translateY(-60%);
				left: 67%;
				font-family: SourceHanSansCN;
				font-weight: 800;
				font-size: 0.9vw;
				color: #1f2c6e;
				cursor: pointer;
				span {
					display: inline-block;
					vertical-align: middle;
				}
				img {
					display: inline-block;
					vertical-align: middle;
					height: 1.2vw;
				}
			}

			.txt3 {
				position: absolute;
				top: 48%;
				transform: translateY(-60%);
				left: 78%;
				font-family: SourceHanSansCN;
				font-weight: 800;
				font-size: 0.9vw;
				color: #1f2c6e;
				cursor: pointer;
				span {
					display: inline-block;
					vertical-align: middle;
				}
				img {
					display: inline-block;
					vertical-align: middle;
					height: 1.2vw;
				}
			}

			background-size: 100% 100%;
		}

		> img {
			position: fixed;
			bottom: 0;
			left: 10vw;
			width: 15vw;
		}
	}

	.welcome-bg {
		position: fixed;
		background-color: rgba(255, 255, 255, 0.1);
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 99;
		background-image: url("@/assets/img/welcome.jpg");
		background-size: cover;
		background-position: center;
		transition: all 0.6s;

		> img {
			position: absolute;
			top: 63.15%;
			left: 50%;
			transform: translateX(-50%);
			width: 11.212vw;
			height: 2.6vw;
			background-color: transparent;
			border-radius: 1.354vw;
			cursor: pointer;
		}
	}

	.process {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		bottom: 13.8vh;
		width: 47.1vw;
		background: linear-gradient(0deg, #fdfeff 0%, #eff5ff 100%);
		border-radius: 0.52vw 0.52vw 0px 0px;
		border: 2px solid #2772ff;
		padding: 4.16vh 3.23vw;
		transition: all 0.8s;
		overflow: auto;

		.close-process {
			position: absolute;
			top: 0.5vw;
			right: 0.5vw;
			cursor: pointer;
			z-index: 1000;
		}

		&-item {
			height: 4.6vh;
			border-bottom: 1px solid #878787;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				&:first-child {
					font-size: 0.85vw;
					color: #000;
					font-weight: bold;
				}

				&:last-child {
					width: 5.5vw;
					height: 2.77vh;
					background: rgb(243, 223, 231);
					border-radius: 5px;
					color: rgba(230, 0, 18, 1);
					font-size: 0.8vw;
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
		}
	}
	.home {
		width: 100%;
		height: 100%;
		background-image: url("@/assets/img/bg1.jpg");
		background-size: 100% 100%;
		background-position: center;
		overflow: hidden;
		position: absolute;
		top: 0;
		left: 0;

		.feed-back {
			position: fixed;
			right: 1vw;
			top: 45.3vh;
			height: 4vh;
			cursor: pointer;
			z-index: 999;
			width: 4.2vw;
			height: 4.2vw;
		}

		.top-bg {
			position: fixed;
			top: 0;
			left: 0;
			right: 0;

			img {
				width: 100%;
			}
		}

		&.is-mobile {
			.process-item span:last-child {
				width: 7vw;
			}
		}

		.close-icon {
			position: absolute;
			right: 2.8vw;
			top: 7vh;
			background-color: transparent;
			z-index: 999;
			width: 2.8vw;
			height: 2.6vw;
			cursor: pointer;
		}

		.operate {
			position: fixed;
			top: 5vh;
			right: 3.4vw;

			img {
				margin-left: 1.04vw;
				cursor: pointer;
				width: 3.1vw;
				height: 3.1vw;
			}
		}

		.swiper-slide-next {
			padding: 0 !important;
			position: relative;
			left: -0.26vw;
		}

		.swiper-container {
			width: 100%;
			position: absolute;
			top: 34.1%;
			left: 0;
			// right: 0;
			overflow-y: hidden;
			perspective: 100vw;
			padding-top: 1%;

			.swiper-wrapper {
				transform-style: preserve-3d;
			}
		}

		.pre-btn {
			position: fixed;
			left: 2vw;
			bottom: 10.9vh;
			cursor: pointer;

			img {
				width: 9.7vw;
				height: 12vh;
			}
		}

		.next-btn {
			position: fixed;
			right: 2vw;
			bottom: 10.9vh;
			cursor: pointer;

			img {
				width: 9.7vw;
				height: 12vh;
			}
		}

		.swiper-slide.swiper-slide-active {
			// border-right: 30px solid #6ac8fa !important;
			padding-right: 0.52vw;
		}

		.swiper-slide.swiper-slide-active::after {
			content: "";
			position: absolute;
			width: 1.562vw;
			height: 100%;
			background-color: #6ac8fa;
			top: 0;
			right: -1.25vw;
			pointer-events: none;
		}

		.swiper-slide {
			display: inline-block;
			width: 33.33%;
			height: 34.3vh;
			background-color: #fff;
			border-right: 2px solid transparent;
			border-left: 2px solid transparent;
		}

		.swiper-slide-next.swiper-slide {
			// border-right: 30px solid #6ac8fa !important;
			// border-left: 30px solid #6ac8fa !important;
		}

		.swiper-slide-next + .swiper-slide {
			// padding-left: 10px;
			// border-left: 30px solid #6ac8fa !important;
		}

		.swiper-slide-next + .swiper-slide::before {
			content: "";
			position: absolute;
			width: 1.562vw;
			height: 100%;
			background-color: #6ac8fa;
			top: 0;
			left: -1.666vw;
			pointer-events: none;
		}

		.swiper-fqqz {
			padding: 0.52vw !important;
			border: none !important;
			box-shadow: none !important;
			background-image: none !important;

			.fqqz-item {
				background-image: url("@/assets/img/fqqz2.png") !important;
				width: 100%;
				height: calc(100%);
				background-size: cover;
				padding: 0;
				position: relative;

				.fqqz-item-img {
					background-image: url("@/assets/img/fqqz1.jpg") !important;
					width: 100%;
					height: 100%;
					background-size: cover;
					position: relative;
					overflow: hidden;
					border-top-left-radius: 2.6vw;
					border-top-right-radius: 2.6vw;

					.door-left {
						position: absolute;
						left: 0;
						top: 0;
						bottom: 0;
						background-image: url("@/assets/img/door-left.png");
						width: 50%;
						height: 100%;
						background-size: 100% 100%;
						border-right: 1px solid #ffffff;
					}

					.door-right {
						position: absolute;
						right: 0;
						top: 0;
						bottom: 0;
						background-image: url("@/assets/img/door-right.png");
						width: 50%;
						height: 100%;
						background-size: 100% 100%;
						border-right: 1px solid #ffffff;
					}
				}
			}
		}

		.swiper-item {
			width: calc(100% - 1.56vw);
			height: calc(100% - 1.56vw);
			margin: 0.78vw;
			display: flex;
			padding: 0.52vw;
			background-position: center;
			background-size: cover;
			justify-content: center;
			align-items: center;
			cursor: default;
			// border: 10px solid #dbdee2;
			box-shadow: inset 0 0 0 0.52vw rgba(0, 0, 0, 0.1);
			position: relative;
		}

		.swiper-slide-next .swiper-item {
			width: 100%;
			height: 100%;
			border: 0.52vw solid #dbdee2;
			margin: 0;
		}

		.door-right,
		.door-left {
			transition: all 2s;
		}

		.swiper-slide-next .door-right,
		.swiper-slide-next .door-left {
			width: 0 !important;
		}
	}

	.bottom-menu {
		position: fixed;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		background-image: url("@/assets/img/p1.png");
		height: 14vh;
		width: 75vw;
		background-size: 100% 100%;
		background-position: center;
		z-index: 99;

		.menu-list {
			width: 70%;
			margin-left: 15%;
			height: 100%;
			display: flex;
			justify-content: space-around;
			align-items: center;
			height: 7vh;
			margin-top: 3vh;

			.menu-item {
				cursor: pointer;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				flex: 1;

				img {
					height: 3.24vh;
				}

				span {
					display: block;
					margin-top: 1.48vh;
					font-size: 0.93vw;
					height: 1.6vh;
					line-height: 1.6vh;
					color: #1d50b6;
				}

				&.active {
					span {
						color: #e64012;
					}
				}

				&:first-child {
					span {
						color: #1d50b6 !important;
					}
				}
			}
		}
	}
}
</style>
